import { API_V2 } from "@Models/GWDomain";
import { ApiResponse, getData } from "@Services/constServices";

const customersBaseUrl = `${API_V2}/customers`;

export const searchCustomers = async (input: string): Promise<ApiResponse> => {
  const url = `${customersBaseUrl}/search/${input}`;
  return getData(url);
};
